appwaiver.directive('jqdatepicker', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {

            if (language.indexOf('Polish') > -1) {
                element.datepicker({
                    firstDay: 1,
                    showOtherMonths: true,
                    changeYear: true,
                    yearRange: "-90:+0",
                    dateFormat: 'mm-dd-yy',
                    dayNames: ["poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota", "niedziela"],
                    dayNamesMin: ["Pon", "Wt", "śr", "czw", "pt", "sb", "nie"],
                    dayNamesShort: ["Pon", "Wt", "śr", "czw", "pt", "sb", "nie"],
                    monthNames: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
                    monthNamesShort: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
                    onSelect: function (date) {
                        scope.kid.Birthday = date;
                        scope.$apply();
                    }
                });
                element.datepicker("option", $.datepicker.regional["pl"]);
            } else {
                element.datepicker({
                    firstDay: 1,
                    showOtherMonths: true,
                    changeYear: true,
                    yearRange: "-90:+0",
                    dateFormat: 'mm-dd-yy',
                    onSelect: function (date) {
                        scope.kid.Birthday = date;
                        scope.$apply();
                    }
                });

                element.datepicker("option", $.datepicker.regional["en"]);
            }


            // language = attrs.lang;
            // if (language.indexOf('Bulgarian') > -1){
            //     element.datepicker( "option", $.datepicker.regional[ "bg" ] );
            // }
            // else if (language.indexOf('Polish') > -1){
            //     element.datepicker( "option", $.datepicker.regional[ "pl" ] );
            // }
            // else{
            //     element.datepicker( "option", $.datepicker.regional[ "en" ] );
            // }
        }
    };
}).directive('cljqdatepicker', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {

            var el = element;

            language = attrs.lang;

            if (language.indexOf('Polish') > -1) {
                element.datepicker({
                    firstDay: 1,
                    showOtherMonths: true,
                    changeYear: true,
                    yearRange: "-90:+0",
                    dateFormat: 'mm-dd-yy',
                    dayNames: ["poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota", "niedziela"],
                    dayNamesMin: ["Pon", "Wt", "śr", "czw", "pt", "sb", "nie"],
                    dayNamesShort: ["Pon", "Wt", "śr", "czw", "pt", "sb", "nie"],
                    monthNames: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
                    monthNamesShort: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
                    onSelect: function (date) {
                        scope.waiverInfo.Client.Birthday = date;
                        scope.$apply();
                    }
                });
                element.datepicker("option", $.datepicker.regional["pl"]);
            } else {
                element.datepicker({
                    firstDay: 1,
                    showOtherMonths: true,
                    changeYear: true,
                    yearRange: "-90:+0",
                    dateFormat: 'mm-dd-yy',
                    onSelect: function (date) {
                        scope.waiverInfo.Client.Birthday = date;
                        scope.$apply();
                    }
                });
                element.datepicker("option", $.datepicker.regional["en"]);

                if (scope.eventsCurrentDay = true) {
                    var today = new Date();
                    el.datepicker("setDate", today);
                }
            }




            // if (language.indexOf('Bulgarian') > -1){
            //     element.datepicker( "option", $.datepicker.regional[ "bg" ] );
            // }
            // else if (language.indexOf('Polish') > -1){
            //     element.datepicker( "option", $.datepicker.regional[ "pl" ] );
            // }
            // else{
            //     element.datepicker( "option", $.datepicker.regional[ "en" ] );
            // }
        }
    };
}).directive("drawing", function () {
    return {
        restrict: "A",
        link: function (scope, element) {
            var ctx = element[0].getContext('2d');

            // variable that decides if something should be drawn on mousemove
            var drawing = false;

            // the last coordinates before the current move
            var lastX;
            var lastY;

            element.bind('mousedown', function (event) {
                if (event.offsetX !== undefined) {
                    lastX = event.offsetX;
                    lastY = event.offsetY;
                } else { // Firefox compatibility
                    lastX = event.layerX - event.currentTarget.offsetLeft;
                    lastY = event.layerY - event.currentTarget.offsetTop;
                }

                // begins new line
                ctx.beginPath();

                drawing = true;
            });
            element.bind('mousemove', function (event) {
                if (drawing) {
                    // get current mouse position
                    if (event.offsetX !== undefined) {
                        currentX = event.offsetX;
                        currentY = event.offsetY;
                    } else {
                        currentX = event.layerX - event.currentTarget.offsetLeft;
                        currentY = event.layerY - event.currentTarget.offsetTop;
                    }

                    draw(lastX, lastY, currentX, currentY);

                    // set current coordinates to last one
                    lastX = currentX;
                    lastY = currentY;
                }

            });
            element.bind('mouseup', function (event) {
                // stop drawing
                drawing = false;
            });

            element.bind('touchstart', function (event) {
                if (event.originalEvent.touches != undefined && event.originalEvent.touches.length != undefined && event.originalEvent.touches.length == 1) {
                    var touch = event.originalEvent.touches[0];
                    lastX = touch.pageX - event.currentTarget.offsetLeft;
                    lastY = touch.pageY - event.currentTarget.offsetTop;
                }
                // begins new line
                ctx.beginPath();

                drawing = true;
            });
            element.bind('touchmove', function (event) {
                if (drawing && event.originalEvent.touches != undefined && event.originalEvent.touches.length != undefined && event.originalEvent.touches.length == 1) {
                    // get current mouse position
                    event.preventDefault();
                    var touch = event.originalEvent.touches[0];
                    currentX = touch.pageX - event.currentTarget.offsetLeft;
                    currentY = touch.pageY - event.currentTarget.offsetTop;

                    draw(lastX, lastY, currentX, currentY);

                    // set current coordinates to last one
                    lastX = currentX;
                    lastY = currentY;
                }

            });
            element.bind('MSPointerMove', function (event) {
                if (drawing && event.originalEvent.touches != undefined && event.originalEvent.touches.length != undefined && event.originalEvent.touches.length == 1) {
                    // get current mouse position
                    event.preventDefault();
                    var touch = event.originalEvent.touches[0];
                    currentX = touch.pageX - event.currentTarget.offsetLeft;
                    currentY = touch.pageY - event.currentTarget.offsetTop;

                    draw(lastX, lastY, currentX, currentY);

                    // set current coordinates to last one
                    lastX = currentX;
                    lastY = currentY;
                }

            });
            element.bind('touchend', function (event) {
                // stop drawing
                drawing = false;
            });

            // canvas reset
            function reset() {
                element[0].width = element[0].width;
            }

            function draw(lX, lY, cX, cY) {
                // line from
                ctx.moveTo(lX, lY);
                // to
                ctx.lineTo(cX, cY);
                // color
                ctx.strokeStyle = "#4bf";
                // draw it
                ctx.stroke();
            }
        }
    };
}).directive('language', ["$translate", "$http", function ($translate, $http) {
    return {
        restrict: 'E',
        replace: true,
        template: '<div id="lang"><a class="country" ng-click="langon=!langon;">\
						<i class="flag {{curlang}}"></i>\
						{{curlang}}\
					</a> \
					<ul class="{{langon}}">\
						<li ng-repeat="lang in languages" ng-class="{\'hover\': curlang != lang}">\
							<a ng-click="setLang(lang)" ng-hide="curlang==lang">\
								<i class="flag {{lang}}"></i>\
								<span>{{lang}}</span>\
							</a>\
						</li>\
					</ul></div>',
        link: function ($scope, el, attrs) {
            $scope.languages = ["en", "bg"]
            $scope.setLang = function (d) {
                $translate.use(d);
                $scope.langon = false;
                $scope.curlang = d;
            }

            if ($scope.curlang == null) {
                $scope.curlang = "en";
            }
        }
    };
}]);